import React from 'react';
import { Header } from '@tanstack/react-table';
import classNames from 'classnames';

import styles from './ColumnResizer.module.scss';

export interface IColumnResizerProps {
    header: Header<any, unknown>;
}

export const ColumnResizer: React.FC<IColumnResizerProps> = ({ header }) => {
    return (
        <div
            className={classNames(styles.resizer, {
                [styles.isResizing]: header.column.getIsResizing(),
            })}
            onDoubleClick={() => header.column.resetSize()}
            onMouseDown={header.getResizeHandler()}
            onTouchStart={header.getResizeHandler()}
        ></div>
    );
};
